import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

function mountApp() {
  const rootElement = document.getElementById('podcast-player-root');

  if (!rootElement) {
    console.error('[CUEBES Podcast Player] Root element not found');
    return;
  }

  const apiRoot = rootElement.dataset.apiRoot || '/wp-json/';
  const apiNonce = rootElement.dataset.apiNonce || '';

  console.log('[CUEBES Podcast Player] Mounting app', { apiRoot });

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App apiRoot={apiRoot} apiNonce={apiNonce} />
    </React.StrictMode>
  );
}

// Mount when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountApp);
} else {
  mountApp();
}
